import { Box, Icon, TextInputNew } from '@jfs/ui-new'
import { useState } from 'react'

export const SearchFilter = ({ onSearchPress, label }: any) => {
  const [searchText, setSearchText] = useState('')
  const [isSearchDone, setIsSearchDone] = useState(false)

  const onValueChanged = (textValue: string) => {
    setIsSearchDone(false)
    setSearchText(textValue)
  }

  return (
    <Box
      h={36}
      flexDirection={'row'}
      borderColor={'DISABLED_GREY'}
      borderWidth={1}
      borderRadius={4}
      mr={16}
      align={'center'}>
      <TextInputNew
        placeholder={label}
        value={searchText}
        onChange={onValueChanged}
        autoFocus={false}
        placeholderTextColor={'BRAND_COLOR_GRAY_1'}
        color={'BLACK'}
        fontSize={12}
        borderColor={'TRANSPARENT'}
        focusBorderColor={'TRANSPARENT'}
        paddingHorizontal={8}
        textWidth={150}
      />
      <Box
        bg={'TEAL'}
        h={36}
        w={36}
        justify={'center'}
        align={'center'}
        testID="search-icon"
        onPress={() => {
          if (isSearchDone) {
            setIsSearchDone(false)
            setSearchText('')
            onSearchPress('')
          } else {
            setIsSearchDone(true)
            onSearchPress(searchText)
          }
        }}
        underlayColor={'TRANSPARENT'}>
        <Icon id={isSearchDone ? 'CLOSE' : 'SEARCH'} color={'BLUE'} />
      </Box>
    </Box>
  )
}
